import { Injectable, inject } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router'
import { Observable } from 'rxjs'

import { Enums } from '@cyborg-monorepo/hunter/common'

import { UserService } from '../modules/shared/services/user.service'

import { AuthService } from './auth.service'

@Injectable()
export class AuthGuard implements CanActivate {
  router = inject(Router)
  private authService = inject(AuthService)
  private userService = inject(UserService)

  /**
   * Allows users to navigate new pages if they are logged in. If the refresh token
   * has reached the half waypoint, then also update the refresh token
   * and allow user to pass on success.
   */
  public canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | Observable<boolean> | UrlTree {
    if (this.authService.isAuthenticated()) {
      this.userService.loadProfile().subscribe((profile) => {
        if (
          profile.company.status === Enums.CompanyStatus.EXPIRED ||
          profile.company.status === Enums.CompanyStatus.REVOKED
        ) {
          this.router.navigateByUrl('premium-gate')
          return
        }
      })
      return true
    }

    // Capture attempted target URL and set as next requested login redirect URL
    this.authService.setLoginRedirectPath(state.url)
    return this.router.parseUrl('/login')
  }
}
